import Tour from './Tour';
import Authentication from './Authentication';
import Admin from './Admin';
import Test from './Test';
import NotFound from './NotFound';

export default {
  install(Vue, options) {
    Vue.use(Tour, options);
    Vue.use(Admin, options);
    Vue.use(Authentication, options);
    Vue.use(Test, options);
    Vue.use(NotFound, options);
  },
};
